PJQ.views.primeContracts.PrimeContractEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'modal-prime-contract-edit'),
        width: '95%',
        maxWidth: 1500,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true,
        canEdit: true
    },
    events: {
        'keydown .input-percent': 'numbersOnly',
        'change .input-percent': 'formatPercent',
        'click .btn-save-email': 'saveEmail',
        'click .btn-save': 'savePrimeContract',
        'click .btn-push-erp': 'pushERP',
        'click .btn-undo-push-erp': 'undoPushERP',
        'click .btn-unlink-erp': 'unlinkERP',
        'click .btn-delete': 'deletePrimeContract',
        'click .btn-close': 'close',
        'click .btn-export': 'exportPrimeContract',
        'click .btn-export-markup': 'exportPrimeContractWithMarkup',
        'click .btn-email': 'email',
        'click .btn-new-change-order': 'newChangeOrder',
        'click .btn-view-change-order': 'viewChangeOrderClicked',
        'click .btn-view-invoice': 'viewInvoiceClicked',
        'click .btn-new-invoice': 'newInvoice',
        'click .btn-view-payment': 'viewPaymentClicked',
        'click .nav-link': 'activeViewChanged',
        'click .btn-view-history': 'viewHistory'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.coreFieldSettings = await this.options.project.fetchPrimeContractFieldSettings();
        this.terms = await this.options.project.fetchPrimeContractTerms();
        this.settings = await this.options.project.fetchPrimeContractSettings();
        this.customFields = await this.options.project.fetchPrimeContractCustomFields();
        this.invoiceSettings = await this.options.project.fetchReceivableInvoiceSettings();
        this.costCodes = this.options.project.fetchCostCodes();
        this.costTypes = this.options.project.fetchCostTypes();
        this.unitsOfMeasure = this.options.project.fetchUnitsOfMeasure();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        if (this.model == null) {
            let customFieldValues = [];
            _.each(this.customFields.models, (model, index) => {
                let value = model.get('defaultValue') ? model.get('defaultValue') : '';
                if (model.get('fieldType') === 'CHOICE') {
                    value = parseInt(value);
                }
                customFieldValues.push({
                    fieldNumber: model.get('fieldNumber'),
                    fieldTypeId: model.get('fieldTypeId'),
                    fieldType: model.get('fieldType'),
                    isMultiple: model.get('isMultiple'),
                    value: value,
                    id: model.get('id')
                })
            });

            this.model = new PJQ.models.primeContracts.PrimeContract({
                accountingMethod: this.settings.get('defaultAccountingMethod'),
                projectId: PJQ.app.session.project.id,
                statusId: PJQ.constants.primeContracts.primeContractStatus.DRAFT,
                createdOn: new Date(Date.now()),
                customFieldValues: customFieldValues
            });
        }

        if (!this.model.isNew()) {
            await this.model.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canViewChangeOrders = this.options.project.hasPermission('primeContractChangeOrders.canView');
        this.options.canAddChangeOrders = this.options.project.hasPermission('primeContractChangeOrders.isAdmin');
        this.options.canViewInvoices = this.options.project.hasPermission('receivableInvoices.canView');
        this.options.canAddInvoices = this.options.project.hasPermission('receivableInvoices.isAdmin');
        this.options.canEdit = this.options.project.hasPermission('primeContracts.canEdit');
        this.options.canUploadAttachments = this.options.canEdit;
        this.options.canEditLineItems = this.options.project.hasPermission('primeContracts.canEditLineItems');
        this.options.isAdmin = this.options.project.hasPermission('primeContracts.isAdmin');
        this.options.canDelete = this.options.isAdmin;
        this.options.canEditStatus = this.options.isAdmin;

        this.options.disabledStatuses = null;
        let fnGetGreaterStatuses = (statusId) => {
                return _.filter(PJQ.constants.commitments.commitmentStatus, (st) => {
                    return st < statusId;
                });
            },
            status = this.model.get('statusId');
        if (status !== PJQ.constants.primeContracts.primeContractStatus.TERMINATED) {
            this.options.canAddChangeOrders = PJQ.app.session.project.hasPermission('primeContractChangeOrders.isAdmin') && (status === PJQ.constants.primeContracts.primeContractStatus.COMPLETE || status === PJQ.constants.primeContracts.primeContractStatus.APPROVED);
            this.options.canAddInvoices = PJQ.app.session.project.hasPermission('receivableInvoices.isAdmin') && (status === PJQ.constants.primeContracts.primeContractStatus.COMPLETE || status === PJQ.constants.primeContracts.primeContractStatus.APPROVED);
        } else {
            this.options.canAddChangeOrders = false;
            this.options.canAddInvoices = false;
        }

        if (this.model.isNew()) {
            this.options.canEdit = true;
            this.options.canUploadAttachments = true;
            this.options.canEditLineItems = true;
        } else if (status === PJQ.constants.primeContracts.primeContractStatus.TERMINATED
            || status === PJQ.constants.primeContracts.primeContractStatus.COMPLETE
            || status === PJQ.constants.primeContracts.primeContractStatus.APPROVED) {
            this.options.canEdit = PJQ.app.session.project.hasPermission('primeContracts.canEdit');
            this.options.canUploadAttachments = this.options.isAdmin;
            this.options.canEditLineItems = false;
            this.options.canDelete = false;
        } else if (status === PJQ.constants.primeContracts.primeContractStatus.OUT_FOR_BID
            || status === PJQ.constants.primeContracts.primeContractStatus.OUT_FOR_SIGNATURE) {
            this.options.canEdit = this.options.isAdmin;
            this.options.canUploadAttachments = true;
            this.options.canEditLineItems = this.options.isAdmin;
        } else {
            this.options.canEdit = PJQ.app.session.project.hasPermission('primeContracts.canEdit');
            this.options.canUploadAttachments = true;
            this.options.canEditLineItems = PJQ.app.session.project.hasPermission('primeContracts.canEditLineItems');
        }

        if (this.model.invoices.models.length > 0 || this.model.changeRequests.models.length > 0) {
            this.options.disabledStatuses = fnGetGreaterStatuses(PJQ.constants.primeContracts.primeContractStatus.APPROVED);
            this.options.canEditLineItems = false;
        }

        if (!this.options.isAdmin && this.settings.get('isMarkupAdmin') === true) {
            this.options.canEditLineItems = false;
        }

        this.options.canEditFinancialMarkups = this.options.canEditLineItems;
        if (this.erpIntegration != null) {
            let syncStatus = this.model.erpSyncStatus();
            if (syncStatus === PJQ.constants.integrations.erp.syncStatuses.REVIEWING
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.APPROVED
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.SYNCED
            ) {
                if (syncStatus === PJQ.constants.integrations.erp.syncStatuses.REVIEWING
                    || syncStatus === PJQ.constants.integrations.erp.syncStatuses.APPROVED
                    || !this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.CAN_ADD_MARKUPS_AFTER_SYNC)) {
                    this.options.canEditFinancialMarkups = false;
                    this.options.disabledStatuses = fnGetGreaterStatuses(PJQ.constants.primeContracts.primeContractStatus.APPROVED);
                }
                // this.options.canEdit = false;
                this.options.canEditLineItems = false;
                this.options.canDelete = false;
            }
        }
    },
    renderData: function () {
        return {
            model: this.model,
            erpIntegration: this.erpIntegration,
            customFields: this.customFields,
            canViewChangeOrders: this.options.canViewChangeOrders,
            canAddChangeOrders: this.options.canAddChangeOrders,
            canViewInvoices: this.options.canViewInvoices,
            canAddInvoices: this.options.canAddInvoices,
            canEdit: this.options.canEdit,
            canEditLineItems: this.options.canEditLineItems,
            canUploadAttachments: this.options.canUploadAttachments,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            isFetched: this.isFetched,
            activeView: this.options.activeView,
            views: this.views,
            terms: this.terms,
            settings: this.settings,
            invoiceSettings: this.invoiceSettings,
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            checkFieldRequired: _.bind(this.checkFieldRequired, this),
            hasPendingInvoice: this.model && this.model.invoices.models.length > 0 && null != _.find(this.model.invoices.models, (invoice) => {
                return invoice.get('statusId') !== PJQ.constants.invoicing.receivableInvoiceStatus.APPROVED
                    && invoice.get('statusId') !== PJQ.constants.invoicing.receivableInvoiceStatus.COMPLETE;
            })
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.activateView(this.options.activeView);

        this.stopListening(this.model.markupItems);
        this.listenTo(this.model.markupItems, 'update', (markup) => {
            if(markup && markup.get('delete') && (markup.lineItem || markup.get('lineItemId'))){
                let lineItem = markup.lineItem ?? this.model.lineItems.findWhere({appliedMarkupId: markup.id});

                if(lineItem){
                    if(lineItem.get('id') > 0){
                        lineItem.set('delete', true);
                    } else {
                        this.model.lineItems.remove(lineItem);
                    }
                }
            }

            this.updateCounts();
            this.lineItemsView.render();
        });

        this.stopListening(this.model);
        this.listenTo(this.model, 'change:statusId', () => {
            this.renderERP();
        });
        this.stopListening(this.model.lineItems);
        this.listenTo(this.model.lineItems, 'update', () => {
            this.renderERP();
        });
        this.renderERP();

        this.renderGeneral();
        this.renderLineItems();

        if (!this.model.isNew()) {
            if (this.options.canViewChangeOrders) {
                this.renderChangeOrders();
            }
            if (this.options.canViewInvoices) {
                this.renderInvoices();
                this.renderPayments();
            }
        }

        this.renderMarkups();

        this.updateCounts();
    },
    updateCounts: function () {
        this.$('.count-line-items').text(_.size(_.filter(this.model.lineItems.models, (item) => {
            return !item.get('delete');
        })));
        this.$('.count-change-orders').text(_.size(this.model.changeOrders.models));
        this.$('.count-invoices').text(_.size(this.model.invoices.models));
        this.$('.count-payments').text(_.size(this.model.payments.models));
        this.$('.count-markups').text(_.size(_.filter(this.model.markupItems.models, function (item) {
            return !item.get('delete');
        })));
    },
    views: {
        GENERAL: 'PC_General',
        LINEITEMS: 'PC_LineItems',
        CHANGEORDERS: 'PC_ChangeOrders',
        INVOICES: 'PC_Invoices',
        PAYMENTS: 'PC_Payments',
        MARKUPS: 'PC_Markups'
    },
    activeViewChanged: function (e) {
        let view = e.target.hash ? e.target.hash.replace('#', '') : null;
        this.activateView(view);
    },
    activateView: function (view) {
        if (view == null) {
            view = this.views.GENERAL;
        }

        this.$('.nav-link[href="#' + view + '"]').tab('show');
        this.options.activeView = view;

        if (view === this.views.LINEITEMS) {
            // this.lineItemsView.adjustColumns();
        }
    },
    renderMarkups: function () {
        if (!this.options.isAdmin) {
            return;
        }

        let syncStatus = this.model.erpSyncStatus();
        this.markupsView = new PJQ.financialMarkups.views.FinancialMarkupsList({
            el: this.$('.pc-markups'),
            collection: this.model.markupItems,
            canEdit: this.options.canEditFinancialMarkups,
            autoVoid: syncStatus === PJQ.constants.integrations.erp.syncStatuses.SYNCED,
            canVoid: true
        });
    },
    renderERP: function () {
        let $erp = this.$('.erp-sync');
        if (!this.options.isAdmin || this.erpIntegration == null || !this.options.project.isERPSynced()
            || false === this.erpIntegration.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACTS)) {
            $erp.remove();
            return;
        }

        let canPush = true,
            disablePushReason = "";
        if (_.size(this.model.lineItems.models) === 0
            || (this.model.get('statusId') !== PJQ.constants.primeContracts.primeContractStatus.APPROVED && this.model.get('statusId') !== PJQ.constants.primeContracts.primeContractStatus.COMPLETE)) {
            canPush = false;
            disablePushReason = "Contract must be approved and have line items";
        }

        PJQ.helpers.erp.renderERPButtons(this.$('.erp-sync'), {
            status: this.model.erpSyncStatus(),
            pushSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PRIME_CONTRACTS),
            canPush: canPush,
            canPushChanges: false,
            disablePushReason: disablePushReason,
            unlinkSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.UNLINK_PRIME_CONTRACTS)
        });
    },
    pushERP: function (callback) {
        if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PRIME_CONTRACTS)) {
            return;
        }

        this.save((success) => {
            if (success) {
                this.erpIntegration.pushPrimeContract(this.model, () => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Contract pushed to ERP'
                    });

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }

                    if (typeof callback === 'function') {
                        callback();
                    } else {
                        this.render();
                    }
                });
            }
        });
    },
    undoPushERP: function () {
        if (this.model.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            this.erpIntegration.undoPush(this.model, () => {
                PJQ.notifications.notify.successNotify({
                    message: 'Contract removed from ERP approval'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.render();
            });
        }
    },
    unlinkERP: function () {
        new PJQ.views.modals.YesNo({
            header: "Unlink from ERP",
            body: "Are you sure you want to unlink this Contract from your ERP system?  This will also unlink all Change Orders and Invoices associated with it.",
            onYes: () => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                this.erpIntegration.unlinkPrimeContract(this.model, _.bind(function (success) {
                    if (success) {
                        loader.remove();
                        PJQ.notifications.notify.successNotify({
                            message: 'Contract unlinked from ERP'
                        });

                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(this.model);
                        }

                        this.render();
                    }
                }, this));
            }
        });
    },
    renderGeneral: function () {
        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });

        this.clientPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.contract-client'),
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            hideUsers: true,
            selectedContact: this.model.client,
            isSingleChoice: true,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: this.options.canEdit,
            onChange: _.bind(function (selectedContact) {
                this.model.client = selectedContact;
                this.model.set('clientId', selectedContact ? selectedContact.id : 0);
            }, this)
        });

        new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.contract-architect'),
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            hideUsers: true,
            selectedContact: this.model.architect,
            isSingleChoice: true,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: this.options.canEdit,
            onChange: _.bind(function (selectedContact) {
                this.model.architect = selectedContact;
                this.model.set('architectId', selectedContact ? selectedContact.id : 0);
            }, this)
        });

        let choices = _.map(PJQ.constants.primeContracts.primeContractStatus, (st) => {
            return {
                id: st,
                name: PJQ.constants.primeContracts.primeContractStatusNames[st],
                disabled: this.options.disabledStatuses != null && this.options.disabledStatuses.indexOf(st) > -1
            }
        });
        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            choices: choices,
            defaultValue: this.model.get('statusId') != null ? this.model.get('statusId') : 2,
            canEdit: this.options.canEditStatus,
            isMultiple: false,
            isIntChoices: true,
            onChange: _.bind(function (newStatus) {
                let oldStatus = this.model.get('statusId');
                if (newStatus === oldStatus) {
                    return;
                }

                this.model.set('statusId', newStatus);
                if (!this.model.isNew()) {
                    this.save((success) => {
                        if (success) {
                            PJQ.notifications.notify.successNotify({
                                message: 'Contract saved successfully'
                            });
                        } else {
                            this.model.set('statusId', oldStatus);
                            this.statusPicker.setValue(oldStatus);
                        }
                    });
                } else {
                    this.render();
                }
            }, this)
        });

        let defaultTerm = _.find(this.terms.models, function (model) {
            return model.get('isDefault');
        }, this);
        if (this.model.isNew() && defaultTerm != null && defaultTerm.id > 0) {
            this.model.set('termsId', defaultTerm.id);
        }
        this.termsPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-terms'),
            isIntChoices: true,
            defaultValue: this.model.get('termsId'),
            canEdit: this.options.canEdit && this.options.isAdmin,
            onChange: _.bind(function (newTermsId) {
                this.model.set('termsId', newTermsId ? newTermsId : 0);
            }, this)
        });

        if (this.checkFieldVisible('attachments')) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.contract-file-uploader'),
                collection: this.model.attachments,
                canUpload: this.options.canUploadAttachments,
                useApiV2: true,
                canView: false,
                canDelete: this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            })
        }

        if (this.checkFieldVisible('signedDocumentAttachments')) {
            this.signedDocumentUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.signed-file-uploader'),
                collection: this.model.signedDocumentAttachments,
                canUpload: this.options.canUploadAttachments,
                useApiV2: true,
                canView: false,
                canDelete: this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
        }

        if (this.checkFieldVisible('executedDocumentAttachments')) {
            this.executedDocumentUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.executed-file-uploader'),
                collection: this.model.executedDocumentAttachments,
                canUpload: this.options.canUploadAttachments,
                useApiV2: true,
                canView: false,
                canDelete: this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
        }

        // Render date pickers in separate function because there are so many
        this.renderDatePickers();

        if (this.customFields && _.size(this.customFields.models) > 0) {
            this.customFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                el: this.$('.prime-contract-custom-fields'),
                collection: this.customFields,
                fieldValues: this.model.get('customFieldValues'),
                isEdit: this.options.canEdit,
                isAdmin: this.options.isAdmin,
            });
        }
    },
    renderDatePickers: function () {
        // These are in order as they are displayed on the page
        new PJQ.inputs.Datepicker({
            el: this.$('.contract-start'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('startOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('startOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('startOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.estimated-completion'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('estimatedCompleteOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('estimatedCompleteOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('estimatedCompleteOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.substantial-completion'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('substantialCompleteOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('substantialCompleteOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('substantialCompleteOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.actual-completion'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('actualCompleteOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('actualCompleteOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('actualCompleteOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.contract-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('contractOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('contractOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('contractOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.signed-contract-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('signedContractOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('signedContractOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('signedContractOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.letter-of-intent'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('letterOfIntentOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('letterOfIntentOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('letterOfIntentOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.approval-letter'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('approvalLetterOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('approvalLetterOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('approvalLetterOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.contract-issued-on'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('issuedOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('issuedOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('issuedOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.execution-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('executedOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('executedOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('executedOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.contract-returned'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('returnedOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('returnedOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('returnedOn', newDate);
                }
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.contract-termination'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('contractTerminatedOn')
            },
            onChange: _.bind(function (newDate) {
                let currentDueDate = this.model.get('contractTerminatedOn');
                if (currentDueDate == null || PJQ.helpers.dateHelpers.getDateDaysDiff(newDate, new Date(currentDueDate)) !== 0) {
                    this.model.set('contractTerminatedOn', newDate);
                }
            }, this)
        });
    },
    formatPercent: function (e) {
        $(e.currentTarget).val(PJQ.helpers.formatHelpers.formatPercent($(e.currentTarget).val()));
    },
    numbersOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e, true, true);
    },
    checkFieldVisible: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isVisible');
            }
        }
        return true;
    },
    checkFieldRequired: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isRequired');
            }
        }
        return false;
    },
    viewHistory: async function () {
        let historyItems = [{
            date: this.model.get('createdOn'),
            person: this.model.get('createdBy'),
            action: 'Contract Created'
        }];

        let history = new PJQ.collections.primeContracts.History({}, {
            primeContractId: this.model.id
        });
        new PJQ.views.history.HistoryTimelineModal({
            collection: history,
            subTitle: 'Contract #' + this.model.get('number'),
            items: historyItems
        });
    },
    exportPrimeContract: function (withMarkup = false) {
        let params = [];
        if (withMarkup === true) {
            params.push({
                parameter: 'withMarkup',
                value: true
            });
        }

        let callback = () => {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'primecontracts',
                    value: this.model.get('id')
                },
                {
                    endpoint: 'export',
                }
            ], params), {isAPIv2: true});
        };
        if (this.options.canEdit && this.model.hasChanged()) {
            this.save(callback);
        } else {
            callback();
        }
    },
    exportPrimeContractWithMarkup: function () {
        this.exportPrimeContract(true);
    },
    renderLineItems: function () {
        if(this.lineItemsView){
            this.lineItemsView.remove();
        }

        this.lineItemsView = new PJQ.views.budget.LineItemsView({
            el: this.$('.line-items'),
            model: this.model,
            collection: this.model.lineItems,
            lineItemModel: PJQ.models.primeContracts.LineItem,
            canEdit: this.options.canEditLineItems,
            canDelete: this.options.canEditLineItems,
            accountingMethod: this.model.get('accountingMethod'),
            canChangeAccountingMethod: this.options.canEditLineItems,
            canImportBudget: true,
            financialMarkups: this.model.markupItems,
            showMarkup: this.options.isAdmin || this.settings.get('isMarkupAdmin') !== true,
            enableTax: true,
            billedToDate: this.options.canViewInvoices && this.model.invoices != null ? () => {
                let res = 0;
                _.each(this.model.invoices.models, function (invoice) {
                    if (invoice.get('statusId') === PJQ.constants.invoicing.receivableInvoiceStatus.APPROVED
                        || invoice.get('statusId') === PJQ.constants.invoicing.receivableInvoiceStatus.COMPLETE) {
                        res += invoice.getGrandTotal();
                    }
                });
                return res;
            } : null,
            showBilling: this.model.get('statusId') === PJQ.constants.primeContracts.primeContractStatus.APPROVED || this.model.get('statusId') === PJQ.constants.primeContracts.primeContractStatus.COMPLETE,
            approvedChanges: this.model.get('approvedChanges'),
            onApprovedChangesClicked: () => {
                this.activateView(this.views.CHANGEORDERS);
            },
            onBilledToDateClicked: () => {
                this.activateView(this.views.INVOICES);
            },
            showSubTotal: true,
            showGrandTotal: true,
            onAccountingMethodChanged: _.bind(function (value) {
                this.model.set('accountingMethod', value);
            }, this),
            onLineItemChange: _.bind(function () {
                this.model.isDirty = true;
            }, this),
            onLineItemAdd: _.bind(function () {
                this.model.isDirty = true;
                this.updateCounts();
            }, this),
            onLineItemDelete: _.bind(function () {
                this.model.isDirty = true;
                this.updateCounts();
            }, this)
        });
    },
    renderChangeOrders: function () {
        if (this.model.isNew()) {
            return;
        }

        this.changeOrderTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.change-orders'),
            data: this.model.changeOrders.models,
            isHideSearch: true,
            language: {
                emptyTable: this.options.canAddChangeOrders ? 'Click "New Change Order" to create a Contract Change Order' : 'No change orders have been created'
            },
            paging: false,
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewChangeOrder(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            return this.options.canViewChangeOrders;
                        }, this)
                    }
                ]
            },
            order: [1, 'asc'],
            hasFooter: true,
            columns: [
                {
                    "columnData": "",
                    "data": null,
                    "title": "",
                    "width": "20px",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": function (data, type, row) {
                        return PJQ.helpers.erp.getERPIcon(row.erpSyncStatus());
                    }
                }, {
                    "data": "attributes.number",
                    "title": "Number",
                    "render": _.bind(function (data, type, row) {
                        if (type === 'sort') {
                            return row.id;
                        }

                        return '<a href="javascript:void(0)" class="btn-view-change-order">' + data + '</a>'
                    }, this)
                }, {
                    "data": "attributes.description",
                    "title": "Description",
                }, {
                    "columnData": "createdOn",
                    "data": "attributes.createdOn",
                    "title": 'Created',
                    "width": '120px',
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('createdOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                    }, this)
                }, {
                    "data": "attributes.invoicedDate",
                    "title": 'Invoiced Date',
                    "width": '120px',
                    "render": _.bind(function (data, type, row) {
                        if (_.size(row.get('invoicedDate')) === 0) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('invoicedDate')), PJQ.helpers.dateHelpers.dateFormats.DATE);
                    }, this)
                }, {
                    "data": "attributes.dueDate",
                    "title": 'Due Date',
                    "width": '120px',
                    "render": _.bind(function (data, type, row) {
                        if (_.size(row.get('dueDate')) === 0) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('invoicedDate')), PJQ.helpers.dateHelpers.dateFormats.DATE);
                    }, this)
                }, {
                    "data": "attributes.statusId",
                    "title": "Status",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.constants.commitments.changeOrderStatusNames[row.get('statusId')];
                    }, this)
                }, {
                    "data": "attributes.amount",
                    "title": "Grand Total",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (changeOrder) {
                            amt += changeOrder.getGrandTotal();
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                }, {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        let html = '<div class="text-align-right show-on-row-hover">'
                        if (this.options.canViewInvoices) {
                            html += '<button type="button" class="btn btn-info btn-view-change-order ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>'
                        }
                        return html + '</div>';
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            onRowDoubleClick: _.bind(function (row) {
                this.viewChangeOrder(row.data());
            }, this)
        });
    },
    newChangeOrder: function () {
        this.viewChangeOrder();
    },
    viewChangeOrderClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.changeOrderTable.getRow(target.closest('tr'));
        this.viewChangeOrder(row.data());
    },
    viewChangeOrder: function (changeOrder) {
        this.removeModal();
        new PJQ.views.primeContracts.ChangeOrderEditModal({
            primeContract: this.model,
            model: changeOrder,
            onSave: _.bind(function (changeOrder, isNew) {
                if (isNew) {
                    this.model.changeOrders.add(changeOrder);
                    this.changeOrderTable.addRow(changeOrder);
                } else {
                    this.changeOrderTable.refresh();
                }
                if (typeof this.options.onChangeOrderAdd === 'function' && isNew) {
                    this.options.onChangeOrderAdd(changeOrder);
                }
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
            onDelete: _.bind(function () {
                let row = this.changeOrderTable.getRow(changeOrder.cid);
                this.model.changeOrders.remove(changeOrder);
                this.changeOrderTable.removeRow(row);
                this.updateCounts()

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this)
        });
    },
    newInvoice: function () {
        this.viewInvoice();
    },
    viewInvoiceClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.invoicesDataTable.getRow(target.closest('tr'));
        this.viewInvoice(row.data());
    },
    viewInvoice: function (invoice) {
        this.removeModal();
        new PJQ.views.invoicing.EditReceivableInvoiceModal({
            primeContract: this.model,
            model: invoice,
            onDelete: _.bind(function () {
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
            onSave: _.bind(function (invoice, isNew) {
                if (isNew) {
                    this.model.invoices.add(invoice);
                    this.invoicesDataTable.addRow(invoice);

                    if (typeof this.options.onInvoiceAdd === 'function') {
                        this.options.onInvoiceAdd(invoice);
                    }
                }
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this)
        });
    },
    viewPaymentClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.paymentsDataTable.getRow(target.closest('tr'));
        this.viewPayment(row.data());
    },
    viewPayment: function (payment) {
        this.removeModal();
        new PJQ.views.invoicing.InvoicePaymentModal({
            model: payment,
            onSave: _.bind(function (payment, isNew) {
                if (isNew) {
                    let invoice = this.model.invoices.get(payment.get('invoiceId'));
                    if (invoice != null) {
                        invoice.payments.add(payment);
                    }

                    this.paymentsDataTable.addRow(invoice);
                }
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
            onDelete: _.bind(function () {
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this)
        });
    },
    deletePrimeContract: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this contract?  All associated change orders and invoices will also be deleted.",
            onDelete: _.bind(function () {
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Contract deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete();

                        this.removeModal();

                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(this.model);
                        }
                    }, this)
                });
            }, this)
        });
    },
    renderInvoices: function () {
        if (this.model.isNew()) {
            return;
        }

        this.invoicesDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.pc-invoices'),
            data: this.model.invoices.models,
            isHideSearch: true,
            language: {
                emptyTable: 'No Invoices have been created yet',
                zeroRecords: "No Invoices matched the search criteria"
            },
            paging: false,
            order: [1, 'asc'],
            hasFooter: true,
            columns: [
                {
                    "columnData": "",
                    "data": null,
                    "title": "",
                    "width": "20px",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": function (data, type, row) {
                        if (row.isERPSynced()) {
                            return PJQ.helpers.erp.getERPIcon(row.erpSyncStatus());
                        }
                        return '';
                    }
                }, {
                    "title": "#",
                    "data": "attributes.number",
                    "render": _.bind(function (data, type, row) {
                        if (type === 'sort') {
                            return row.id;
                        }

                        return '<a href="javascript:void(0)" class="btn-view-invoice">' + data + '</a>'
                    }, this)
                },
                {
                    "title": 'Billing Period',
                    "data": "",
                    "render": _.bind(function (data, type, row) {
                        let periodStart = PJQ.helpers.dateHelpers.getDateString(new Date(row.get('startDate')), PJQ.helpers.dateHelpers.dateFormats.DATE, true),
                            periodEnd = PJQ.helpers.dateHelpers.getDateString(new Date(row.get('endDate')), PJQ.helpers.dateHelpers.dateFormats.DATE, true);

                        return (periodStart) + ' - ' + (periodEnd);
                    }, this)
                },
                {
                    "title": 'Due Date',
                    "data": "",
                    "width": '90px',
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('billingDate')), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                    }, this)
                },
                {
                    "data": "",
                    "title": "Status",
                    "width": "100px",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.constants.invoicing.receivableInvoiceStatusNames[row.get('statusId')]
                    }, this)
                },
                {
                    "data": "attributes.amount",
                    "title": "Retainage",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getRetainage());
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (invoice) {
                            amt += invoice.getRetainage();
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                {
                    "data": "attributes.amount",
                    "title": "Grand Total",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                    }, this),
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (invoice) {
                            amt += invoice.getGrandTotal();
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "40px",
                    "render": _.bind(function (data, type, row) {
                        let html = '<div class="text-align-right show-on-row-hover">'
                        if (this.options.canViewInvoices) {
                            html += '<button type="button" class="btn btn-info btn-view-invoice ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>'
                        }
                        return html + '</div>';
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewInvoice(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            return this.options.canViewInvoices;
                        }, this)
                    }
                ]
            },
            onRowDoubleClick: _.bind(function (row) {
                this.viewInvoice(row.data());
            }, this)
        });
    },
    renderPayments: function () {
        if (this.model.isNew() || !this.invoiceSettings.get('enablePayments')) {
            return;
        }

        this.paymentsDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.pc-payments'),
            data: this.model.payments.models,
            isHideSearch: true,
            language: {
                emptyTable: 'No Payments have been created yet',
                zeroRecords: "No Payments matched the search criteria"
            },
            paging: false,
            order: [1, 'asc'],
            hasFooter: true,
            columns: [{
                "columnData": "",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": function (data, type, row) {
                    if (row.isERPSynced()) {
                        return PJQ.helpers.erp.getERPIcon(row.erpSyncStatus());
                    }
                    return '';
                }
            },
                {
                    "title": "#",
                    "data": "attributes.number",
                    "render": _.bind(function (data, type, row) {
                        if (type === 'sort') {
                            return row.id;
                        }

                        return '<a href="javascript:void(0)" class="btn-view-payment">' + data + '</a>'
                    }, this)
                },
                {
                    "title": "Check #",
                    "data": "attributes.checkNumber"
                },
                {
                    "title": 'Received',
                    "data": "",
                    "render": _.bind(function (data, type, row) {
                        let dateReceived = row.get('dateReceived');
                        if (_.size(dateReceived) === 0) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(dateReceived), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                    }, this)
                },
                {
                    "title": "Payment Method",
                    "data": "attributes.paymentMethod",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.constants.invoicing.paymentMethods.find(item => item.toLowerCase() === data.toLowerCase()) ?? '';
                    }, this)
                },
                {
                    "data": "attributes.amount",
                    "title": "Amount",
                    "render": (data, type, row) => {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                    },
                    "renderFooter": function (data) {
                        let amt = 0;
                        _.each(data, function (payment) {
                            amt += payment.get('amount');
                        });
                        return PJQ.helpers.formatHelpers.formatCurrency(amt);
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        let html = '<div class="text-align-right show-on-row-hover">'
                        if (this.options.canViewInvoices) {
                            html += '<button type="button" class="btn btn-info btn-view-payment ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>'
                        }
                        return html + '</div>';
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewPayment(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            return this.options.canViewInvoices;
                        }, this)
                    }
                ]
            },
            onRowDoubleClick: _.bind(function (row) {
                this.viewPayment(row.data());
            }, this)
        });
    },
    validate: function () {
        if(!this.options.canEdit || this.model.isERPSynced()){
            return true;
        }

        let isValid = true;
        if (!this.clientPicker.validate()) {
            isValid = false;
        }
        if (this.customFieldsForm != null && !this.customFieldsForm.validate()) {
            isValid = false;
        }

        if (this.checkFieldRequired('number')) {
            let $number = this.$('.prime-contract-number');
            PJQ.helpers.inputHelpers.setInputError($number, true);
            if (_.size(this.model.get('number')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($number, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('defaultWorkRetainagePercent')) {
            let $workRetainage = this.$('.default-work-retainage');
            PJQ.helpers.inputHelpers.setInputError($workRetainage, true);
            if (this.model.get('defaultWorkRetainagePercent') == null) {
                PJQ.helpers.inputHelpers.setInputError($workRetainage, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('defaultMaterialRetainagePercent')) {
            let $materialRetainage = this.$('.default-material-retainage');
            PJQ.helpers.inputHelpers.setInputError($materialRetainage, true);
            if (this.model.get('defaultMaterialRetainagePercent') == null) {
                PJQ.helpers.inputHelpers.setInputError($materialRetainage, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('termsId')) {
            let $terms = this.$('.select-terms');
            PJQ.helpers.inputHelpers.setInputError($terms, true);
            if (this.model.get('termsId') == null || this.model.get('termsId') === 0) {
                PJQ.helpers.inputHelpers.setInputError($terms, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('description')) {
            let $description = this.$('.contract-description');
            PJQ.helpers.inputHelpers.setInputError($description, true);
            if (_.size(this.model.get('description')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($description, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('startOn')) {
            let $startDate = this.$('.contract-start');
            PJQ.helpers.inputHelpers.setInputError($startDate, true);
            if (this.model.get('startOn') == null || this.model.get('startOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($startDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('estimatedCompleteOn')) {
            let $estimatedCompletionDate = this.$('.estimated-completion');
            PJQ.helpers.inputHelpers.setInputError($estimatedCompletionDate, true);
            if (this.model.get('estimatedCompleteOn') == null || this.model.get('estimatedCompleteOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($estimatedCompletionDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('substantialCompleteOn')) {
            let $substantialCompletionDate = this.$('.substantial-completion');
            PJQ.helpers.inputHelpers.setInputError($substantialCompletionDate, true);
            if (this.model.get('substantialCompleteOn') == null || this.model.get('substantialCompleteOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($substantialCompletionDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('actualCompleteOn')) {
            let $actualCompletionDate = this.$('.actual-completion');
            PJQ.helpers.inputHelpers.setInputError($actualCompletionDate, true);
            if (this.model.get('actualCompleteOn') == null || this.model.get('actualCompleteOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($actualCompletionDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('contractOn')) {
            let $contractDate = this.$('.contract-date');
            PJQ.helpers.inputHelpers.setInputError($contractDate, true);
            if (this.model.get('contractOn') == null || this.model.get('contractOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($contractDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('signedContractOn')) {
            let $signedContractDate = this.$('.signed-contract-date');
            PJQ.helpers.inputHelpers.setInputError($signedContractDate, true);
            if (this.model.get('signedContractOn') == null || this.model.get('signedContractOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($signedContractDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('letterOfIntentOn')) {
            let $letterOfIntentDate = this.$('.letter-of-intent');
            PJQ.helpers.inputHelpers.setInputError($letterOfIntentDate, true);
            if (this.model.get('letterOfIntentOn') == null || this.model.get('letterOfIntentOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($letterOfIntentDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('approvalLetterOn')) {
            let $approvalLetterDate = this.$('.approval-letter');
            PJQ.helpers.inputHelpers.setInputError($approvalLetterDate, true);
            if (this.model.get('approvalLetterOn') == null || this.model.get('approvalLetterOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($approvalLetterDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('issuedOn')) {
            let $issuedOnDate = this.$('.contract-issued-on');
            PJQ.helpers.inputHelpers.setInputError($issuedOnDate, true);
            if (this.model.get('issuedOn') == null || this.model.get('issuedOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($issuedOnDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('executedOn')) {
            let $executedOnDate = this.$('.execution-date');
            PJQ.helpers.inputHelpers.setInputError($executedOnDate, true);
            if (this.model.get('executedOn') == null || this.model.get('executedOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($executedOnDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('returnedOn')) {
            let $returnedOnDate = this.$('.contract-returned');
            PJQ.helpers.inputHelpers.setInputError($returnedOnDate, true);
            if (this.model.get('returnedOn') == null || this.model.get('returnedOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($returnedOnDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('contractTerminatedOn')) {
            let $contractTerminatedOnDate = this.$('.contract-termination');
            PJQ.helpers.inputHelpers.setInputError($contractTerminatedOnDate, true);
            if (this.model.get('contractTerminatedOn') == null || this.model.get('contractTerminatedOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($contractTerminatedOnDate, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('inclusions')) {
            let $inclusions = this.$('.inclusions');
            PJQ.helpers.inputHelpers.setInputError($inclusions, true);
            if (_.size(this.model.get('inclusions')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($inclusions, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('exclusions')) {
            let $exclusions = this.$('.exclusions');
            PJQ.helpers.inputHelpers.setInputError($exclusions, true);
            if (_.size(this.model.get('exclusions')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($exclusions, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('attachments')) {
            this.fileUploader.clearError();
            let hasValidAttachment = _.find(this.model.attachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.fileUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('signedDocumentAttachments')) {
            this.signedDocumentUploader.clearError();
            let hasValidAttachment = _.find(this.model.signedDocumentAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.signedDocumentUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('executedDocumentAttachments')) {
            this.executedDocumentUploader.clearError();
            let hasValidAttachment = _.find(this.model.executedDocumentAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.executedDocumentUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (!isValid) {
            this.activateView(this.views.GENERAL);
            return isValid;
        }

        if (!this.lineItemsView.validate()) {
            isValid = false;
            this.activateView(this.views.LINEITEMS);
            return isValid;
        }

        return isValid;
    },
    saveEmail: function () {
        this.save((success) => {
            if (success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Contract saved successfully'
                });

                this.email();
            }
        });
    },
    savePrimeContract: function () {
        this.save((success) => {
            if (success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Contract saved successfully'
                });
                this.removeModal()
            }
        });
    },
    save: function (callback) {
        if (!this.validate()) {
            this.$('.modal').prevObject.scrollTop(0);
            if (typeof callback === 'function') {
                callback(false);
            }
            return;
        }

        this.model.save(null, {
            success: () => {
                this.render();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                PJQ.app.session.project.trigger('contractChanged', this.model);
                if (typeof callback === 'function') {
                    callback(true);
                }
            },
            error: () => {
                if (typeof callback === 'function') {
                    callback(false);
                }
                PJQ.notifications.notify.errorNotify({
                    message: "Encountered an error while saving this Contract. Please contact customer service."
                });
            }
        })
    },
    email: function () {
        let projectName = this.options.project?.get('projectName')?.trim();
        let subject = `A Contract has been shared with you ${projectName && _.size(projectName) > 0 ? `for ${projectName}` : ''}`;
        new PJQ.views.email.ComposeEmailModal({
            header: "Email Contract",
            project: PJQ.app.session.project,
            subject: subject,
            onSave: _.bind(function (data) {
                this.model.share(data, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Contract email sent'
                    });
                }, this));
            }, this)
        });
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.savePrimeContract();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});